"use client";

import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import Payment from "app/components/Payment";
import { Dispatch, SetStateAction } from "react";

const stripePromise = loadStripe(process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY as string);

const StripeRegister = ({
  inputOnly,
  cvcOnly,
  customerCd,
  setIsEditing,
}: {
  inputOnly?: boolean;
  cvcOnly?: boolean;
  customerCd?: string;
  setIsEditing?: Dispatch<SetStateAction<boolean>>;
}) => {
  return (
    <Elements stripe={stripePromise} options={{ appearance: { theme: "flat" } }}>
      <Payment
        inputOnly={inputOnly}
        cvcOnly={inputOnly ? cvcOnly : false}
        customerCd={customerCd}
        setIsEditing={setIsEditing}
      />
    </Elements>
  );
};

export default StripeRegister;
